module.exports = __webpack_public_path__ + "img/justify_left.09c40f41.svg";